import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    RCA040DA40Response: {},
    RCA040FA40Response: {},
    RBF1605T41Response: {},
    //결재진행내역 검색 조건
    approvalSearch: {
      aprvalStus: "0", //결재상태
      inquryStartDd: "", //조회시작일
      inquryEndDd: "", //조회종료일
      corpBzwkCd: "", //거래종류
      drwotAcno: "", //출금계좌번호
      drwotAcnoValue: "",
      regiWwwBnkgLginId: "", //등록자
      page: 1,
    },
    approvalInfo: {}, //결재정보
    approvalRes: {}, //결재상신 결과 정보
    aprvalCnt: 0, //결재할 내역 건수
    approvalType: "", //결재승인:1, 결재반송:2, 상신취소:3
  };
};

const approvalInfo = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default approvalInfo;
